import _t from 'i18n!nls/author-assignment-grading';

export const getLearnerCommentLabel = () => _t('Comment for Learner');
export const getPartnerCommentLabel = () => _t('Comment for Course Staff');

export default {
  getLearnerCommentLabel,
  getPartnerCommentLabel,
};
